export default __webpack_public_path__ + "static/poster-53de31029c5c0c83e99f97516a3bc73e.png";